import AddOtherRegistryPage from './add-other-registry-page'

export default AddOtherRegistryPage
